module.exports = __webpack_public_path__ + "img/HomeImage.5f9a29b6.png";